import { render, staticRenderFns } from "./FeedTags_SearchResultsSection.vue?vue&type=template&id=531b80f2&scoped=true&"
import script from "./FeedTags_SearchResultsSection.vue?vue&type=script&lang=js&"
export * from "./FeedTags_SearchResultsSection.vue?vue&type=script&lang=js&"
import style0 from "./FeedTags_SearchResultsSection.vue?vue&type=style&index=0&id=531b80f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531b80f2",
  null
  
)

export default component.exports